export default "__VITE_ASSET__oa39Nzxn__"